// Library methods

// Utils
import { POST } from '../../../utils/fetchWrappers';

// API URLs
import { API_GET_ALL_USER_CHECKERS } from '../../../utils/API/apiUrls';

// API Status Codes
import { apiStatusCodes } from '../../../utils/API/apiStatusCodes';

// Redux Actions
import * as userVerificationActions from './userVerification.actions';

// Constants
import { FETCH_VERIFIED_USER_REQUEST } from './userVerification.constants';
import { takeLatest, put, call } from 'redux-saga/effects';

export function* fetchVerificationUserDetails(actions) {
    yield put(userVerificationActions.showLoader());
    try {
        const { payload } = actions;
        const { data } = yield call(POST, API_GET_ALL_USER_CHECKERS, payload);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(userVerificationActions.fetchVerifiedUserSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                userVerificationActions.fetchVerifiedUserError({
                    error: data.errorMessage,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(
            userVerificationActions.fetchVerifiedUserError({ error: data })
        );
    }
    yield put(userVerificationActions.hideLoader());
}

/**
 * WATCHER SAGA
 */
export function* userVerificationSaga() {
    yield takeLatest(FETCH_VERIFIED_USER_REQUEST, fetchVerificationUserDetails);
}
